import React, { useRef, useState, useContext, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import { useTheme } from "@material-ui/core/styles";
import MyDailogModal from "../../Commons/myDailogModal";
import useStyles from "./styles.js";
import {
  WebContext,
  IsEmail,
  postPrivateApi,
  getDomainValue,
  captureEvent,
} from "../../../Utility";
import { HEADER_LOGIN_BUTTON_CLICK } from "../../../utils/gtm-events";
import {
  TextInput,
  StyledTypographyBlack,
  StyledButtonPrimary,
} from "../../Commons/styledTabs";
import {
  COUNTRY,
  API_DOMAIN_B2B2C,
  API_SECTION_AUTH,
  API_ENDPOINT_REQUEST_OTP,
  API_ENDPOINT_SIGN_UP,
  API_ENDPOINT_VERIFY_OTP,
  LEO_CAPTCHA_SITE_KEY,
} from "../../../Constants";
import LocalStorage from "../../../LocalStorage";
import CloseIcon from "@material-ui/icons/Close";
import InputOtp from "./inputOtp";
import Autocomplete from "@material-ui/lab/Autocomplete";
const DEFAULT_COUNTRY_ISD_CODE = "+91";
const Login = ({
  setUserInfo = () => {},
  userInfo = {},
  errMsg = "",
  requestOtp = () => {},
  mobileNumberRef,
}) => {
  const [errors, setErrors] = useState({});
  const captchaRef = useRef();
  const classes = useStyles();
  const theme = useTheme();

  const captchaHandleSubmit = (e) => {
    let newErr = {};
    const token = captchaRef.current.getValue();
    if (token) {
      validateMobile();
    } else {
      newErr["captcha"] = "Captcha Not Attempted! Try Again";
      setErrors(newErr);
    }
  };

  const LoginCountryCode = () => (
    <Autocomplete
      size="small"
      options={COUNTRY}
      value={
        COUNTRY.find((item) => item.value === userInfo.countryCode) || null
      }
      getOptionLabel={(option) => option.label}
      onChange={(event, newValue) => {
        setUserInfo({
          ...userInfo,
          countryCode: newValue ? newValue.value : "",
        });
      }}
      disableClearable={true}
      renderOption={(option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          style={{ width: 150, marginRight: 8 }}
          placeholder={DEFAULT_COUNTRY_ISD_CODE}
          variant="outlined"
        />
      )}
    />
  );

  const validateMobile = () => {
    const { countryCode = "" } = userInfo || {};
    let newErr = {};
    if (countryCode == "+91" && mobileNumberRef.current.length != 10) {
      newErr["phone"] = "Please provide 10 digit mobile number";
      setErrors(newErr);
    } else if (
      (countryCode == "+91" && mobileNumberRef.current.length == 10) ||
      countryCode != "+91"
    ) {
      requestOtp(captchaRef.current.getValue());
      captchaRef.current.reset();
    }
  };

  const handleKeyPressOtpRequest = (e) => {
    let { key = "" } = e;
    if (key == "Enter") {
      captchaHandleSubmit();
    }
  };

  return (
    <Box
      minHeight={450}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      height={"100%"}
    >
      {errMsg ? (
        <StyledTypographyBlack
          variant="h4"
          style={{
            textAlign: "center",
            color: theme.agentTheme.background.primary_text,
          }}
        >
          Login In
        </StyledTypographyBlack>
      ) : (
        <StyledTypographyBlack
          variant="h4"
          style={{
            textAlign: "center",
            color: theme.agentTheme.background.primary_text,
          }}
        >
          Login In/Sign Up
        </StyledTypographyBlack>
      )}
      {errMsg.length > 0 && (
        <StyledTypographyBlack
          style={{
            color: theme.agentTheme.destructive.main,
            textAlign: "center",
            marginTop: "8px",
          }}
        >
          {errMsg}
        </StyledTypographyBlack>
      )}
      <Box
        width={"100%"}
        ml={"auto"}
        mt={"40px"}
        textAlign={"center"}
        justifyContent="center"
      >
        <Box display={"flex"} mt={"10%"} width={"100%"}>
          <Box width={"100%"}>
            <InputLabel
              error={errors["phone"]}
              style={{
                paddingBottom: "1rem",
                textAlign: "left",
              }}
            >
              Mobile Number
            </InputLabel>
            <Box display={"flex"}>
              <LoginCountryCode />
              <TextInput
                errors={errors}
                id="cellContactNumber"
                ref={mobileNumberRef}
                styleClass={classes.mobileTextInput}
                onChange={(e) => {
                  mobileNumberRef.current = e.target.value;
                }}
                variant="outlined"
                autoFocus
                onKeyPress={handleKeyPressOtpRequest}
                type="number"
                labelClass={classes.travellerInputTextField}
                placeholder={"Enter Mobile Number"}
              />
            </Box>
          </Box>
        </Box>
        {errors["phone"] && (
          <FormHelperText style={{ color: "#D81111" }}>
            {errors["phone"]}
          </FormHelperText>
        )}
        <Box mt={"30%"}>
          <Box
            error={errors["captcha"]}
            display={"flex"}
            alignItems="center"
            flexDirection={"column"}
          >
            <ReCAPTCHA
              size="normal"
              sitekey={LEO_CAPTCHA_SITE_KEY}
              ref={captchaRef}
            />{" "}
            {errors["captcha"] && (
              <FormHelperText style={{ color: "#D81111" }}>
                {errors["captcha"]}
              </FormHelperText>
            )}
          </Box>
          <StyledButtonPrimary
            id="submit-button"
            variant="extended"
            size="large"
            onClick={() => {
              captchaHandleSubmit();
            }}
            className={classes.buttonWidth}
          >
            Request Otp
          </StyledButtonPrimary>
        </Box>
      </Box>
    </Box>
  );
};

const SignUp = ({
  usernameRef = "",
  emailRef = "",
  userInfo,
  setUserInfo = () => {},
  onClose = () => {},
  domainStr = "",
  setShowSignUp = () => {},
  mobileNumberRef,
  setShowOtp = () => {},
}) => {
  const { countryCode = DEFAULT_COUNTRY_ISD_CODE } = userInfo || {};
  const captchaRef = useRef(null);
  const theme = useTheme();
  let {
    setViewSnackbar,
  } = useContext(WebContext);
  const [errors, setErrors] = useState({});
  const classes = useStyles();


  const SignUpCountryCode = () => (
    <Autocomplete
      size="small"
      options={COUNTRY}
      value={
        COUNTRY.find((item) => item.value === userInfo.countryCode) || null
      }
      getOptionLabel={(option) => option.label}
      onChange={(event, newValue) => {
        setUserInfo({
          ...userInfo,
          countryCode: newValue ? newValue.value : "",
        });
      }}
      disableClearable={true}
      renderOption={(option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          style={{ width: 150, marginRight: 8 }}
          placeholder={DEFAULT_COUNTRY_ISD_CODE}
          variant="outlined"
        />
      )}
    />
  );

  const signUpValidation = () => {
    let error = {};
    const username = usernameRef.current;
    const email = emailRef.current;
    const contactNo = mobileNumberRef.current;
    const token = captchaRef.current.getValue();
    if (username.length < 2) {
      error["username"] = "Name is not valid";
    }
    if (!IsEmail(email)) {
      error["email"] = "Email is not valid";
    }
    if (countryCode == "+91" && contactNo.length !== 10) {
      error["phone"] = "Please provide 10 digit mobile number";
    }
    if (contactNo.length < 2) {
      error["phone"] = "Please provide valid mobile number";
    }
    if (!token) {
      error["captcha"] = "Captcha Not Attempted! Try Again";
    }
    setErrors(error);
    if (Object.keys(error).length > 0) {
      return;
    } else {
      signUp();
    }
  };

  const signUp = async () => {
    const username = usernameRef.current;
    const email = emailRef.current;
    const contactNo = mobileNumberRef.current;
    if (!contactNo || !username || !email) return;

    const {
      data = {},
      status,
      err = null,
    } = await postPrivateApi(
      `${API_DOMAIN_B2B2C}${API_SECTION_AUTH}${API_ENDPOINT_SIGN_UP}`,
      {
        mobile: contactNo,
        full_name: username,
        email: email,
        country_code: userInfo.countryCode.trim().replace("+", ""),
      },
      { Domain: domainStr, "captcha-token": captchaRef.current.getValue() }
    );

    if (status == 400) {
      let { response = "" } = err;
      let { data = {} } = response;
      let { code = "" } = data;
      if (code == "INSUFFCNT_DATA") {
        setViewSnackbar({ type: "error", message: "Something went wrong" });
      } else {
        setShowSignUp(false);
      }
    } else if (status >= 200 && status < 300) {
      setShowOtp(true);
    } else if (!data || err) {
      setViewSnackbar({ type: "error", message: "Something went wrong" });
      onClose();
    }
    if (captchaRef && captchaRef.current && captchaRef.current.reset)
      captchaRef.current.reset();
  };

  return (
    <Box>
      <StyledTypographyBlack
        variant="h4"
        style={{
          textAlign: "center",
          color: theme.agentTheme.background.foreground,
        }}
      >
        Sign Up
      </StyledTypographyBlack>
      <Box width={"90%"} m={"auto"} mt={3}>
        <TextInput
          id="username"
          formControlLabel={"Name"}
          styleClass={`${classes.signUpTextInput} ${classes.fullWidthBox}`}
          ref={usernameRef}
          onChange={(e) => (usernameRef.current = e.target.value)}
          variant="outlined"
          errors={errors}
          type="text"
          labelClass={classes.travellerInputTextField}
          placeholder={"Enter Your Full Name"}
        />
        <Box mt={"5%"}>
          <InputLabel error={errors["phone"]} style={{ paddingBottom: "8px" }}>
            Mobile Number
          </InputLabel>
          <Box display={"flex"}>
            <SignUpCountryCode />
            <TextInput
              errors={errors}
              id="phone"
              defaultValue={mobileNumberRef.current}
              ref={mobileNumberRef}
              onChange={(e) => (mobileNumberRef.current = e.target.value)}
              variant="outlined"
              styleClass={`${classes.signUpTextInput} ${classes.mobileInputStyle}`}
              type="number"
              labelClass={classes.travellerInputTextField}
              placeholder={"Enter Mobile Number"}
            />
          </Box>
        </Box>
        <Box mt={"5%"}>
          <TextInput
            errors={errors}
            id="email"
            ref={emailRef}
            styleClass={`${classes.signUpTextInput} ${classes.fullWidthBox}`}
            onChange={(e) => (emailRef.current = e.target.value)}
            variant="outlined"
            formControlLabel={"Email"}
            type="text"
            labelClass={classes.travellerInputTextField}
            placeholder={"company@email.com"}
          />
        </Box>

        <Box mt={"10%"} textAlign={"center"}>
          <Box
            mt={"5%"}
            error={errors["captcha"]}
            display={"flex"}
            alignItems="center"
            flexDirection={"column"}
          >
            <ReCAPTCHA
              size="normal"
              sitekey={LEO_CAPTCHA_SITE_KEY}
              ref={captchaRef}
            />
            {errors["captcha"] && (
              <FormHelperText style={{ color: "#F44336" }}>
                {errors["captcha"]}
              </FormHelperText>
            )}
          </Box>
          <StyledButtonPrimary
            variant="extended"
            size="large"
            onClick={signUpValidation}
            className={classes.buttonWidth}
          >
            Create Account
          </StyledButtonPrimary>
        </Box>
      </Box>
    </Box>
  );
};

const LoginSignUpModal = ({
  onClose = () => {},
  errMsg = "",
  onVerificationSuccess = () => {},
}) => {
  const theme = useTheme();
  const [showOtp, setShowOtp] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [isTimerPlaying, setIsTimerPlaying] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const [userInfo, setUserInfo] = useState({
    countryCode: DEFAULT_COUNTRY_ISD_CODE,
  });
  const [otpError, setOtpError] = useState({ status: false, msg: "" });
  let { deskTopView = false, setViewSnackbar } = useContext(WebContext);
  const domainStr = getDomainValue();
  const mobileNumberRef = useRef(0);
  const usernameRef = useRef("");
  const emailRef = useRef("");

  useEffect(() => {
    captureEvent(HEADER_LOGIN_BUTTON_CLICK);
  }, []);

  const requestOtp = async (captchaToken) => {
    let { countryCode = "" } = userInfo;
    if (!countryCode || !mobileNumberRef.current) return;
    setIsTimerPlaying(true);
    setIsDisabled(true);
    const {
      data = {},
      status,
      err = null,
    } = await postPrivateApi(
      `${API_DOMAIN_B2B2C}${API_SECTION_AUTH}${API_ENDPOINT_REQUEST_OTP}`,
      {
        mobile: countryCode.replace("+", "") + mobileNumberRef.current,
      },
      { Domain: domainStr, "captcha-token": captchaToken || "" }
    );

    if (status == 403) {
      let { response = {} } = err;
      let { data: errData = {} } = response;
      let { details = "", code = "" } = errData;
      if (code == "USR_BLCKD")
        setViewSnackbar({ type: "error", message: details });
      return;
    } else if (status == 404) {
      setShowSignUp(true);
    } else if (status >= 200 && status < 300) {
      setShowOtp(true);
    } else if (!data || err) {
      setViewSnackbar({ type: "error", message: "Something went wrong" });
      onClose();
    }
  };

  const verifyOtp = async (otp = "") => {
    if (!userInfo || !mobileNumberRef.current || !otp || otp.length < 4) return;
    let { countryCode = "" } = userInfo;
    const {
      data = {},
      status,
      err = null,
    } = await postPrivateApi(
      `${API_DOMAIN_B2B2C}${API_SECTION_AUTH}${API_ENDPOINT_VERIFY_OTP}`,
      {
        mobile: countryCode.trim().replace("+", "") + mobileNumberRef.current,
        otp: otp,
      },
      { Domain: domainStr }
    );

    if (status >= 200 && status < 300) {
      let { token = "", full_name: username = "", email = "" } = data || {};
      let tokenObj = {
        data: { auth_tokens: { access_token: token } },
        username: username,
        userCountryCode: countryCode,
        userPhone: mobileNumberRef.current,
        email: email,
      };
      LocalStorage.setUser(tokenObj);
      onClose();
      onVerificationSuccess();
      setViewSnackbar({ type: "success", message: "Login Successful" });
    } else if (status == 403) {
      //error handle for user blocked and incorrect otp
      let { response = {} } = err;
      let { data: errData = {} } = response;
      let { details = "" } = errData;
      setOtpError({ status: true, msg: details });
    } else if (!data || err) {
      setViewSnackbar({ type: "error", message: "Something went wrong" });
      onClose();
    }
  };

  const ShowBody = () => {
    if (showOtp) {
      return (
        <InputOtp
          verifyOtp={verifyOtp}
          requestOtp={requestOtp}
          isDisabled={isDisabled}
          setIsDisabled={setIsDisabled}
          isTimerPlaying={isTimerPlaying}
          setIsTimerPlaying={setIsTimerPlaying}
          otpError={otpError}
          deskTopView={deskTopView}
        />
      );
    } else if (showSignUp) {
      return (
        <SignUp
          onClose={onClose}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          domainStr={domainStr}
          setShowSignUp={setShowSignUp}
          mobileNumberRef={mobileNumberRef}
          setShowOtp={setShowOtp}
          usernameRef={usernameRef}
          emailRef={emailRef}
        />
      );
    } else {
      return (
        <Login
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          errMsg={errMsg}
          requestOtp={requestOtp}
          mobileNumberRef={mobileNumberRef}
        />
      );
    }
  };

  return (
    <MyDailogModal
      titleText={
        <Box display={"flex"} justifyContent={"flex-end"}>
          <CloseIcon
            onClick={onClose}
            style={{ color: theme.agentTheme.background.primary_text }}
          />
        </Box>
      }
      bodyText={<ShowBody />}
      actions={[]}
      openDailog={true}
      onClose={onClose}
      fullScreen={deskTopView ? false : true}
      maxWidth={deskTopView ? "xs" : "md"}
    />
  );
};

export default LoginSignUpModal;
